import AdminPropertiesForm from "../../../components/Admin/AdminPropertiesForm/AdminPropertiesForm";

type Props = {};

const AdminAddPropertiesPage = (props: Props) => {
  return <AdminPropertiesForm title="Add new property" />;
};

export default AdminAddPropertiesPage;
